<template>
  <div class="info">
    <p><strong>Tevékenységi kör</strong></p>
    <p>{{data.activity}}</p>
    <p><strong>Nyitvatartás</strong></p>
    <p>{{data.opening}}</p>
    <p><strong>Programtípusok</strong></p>
    <p><span v-for="type in data.program_types">{{type}}</span></p>
    <div v-if="data.organizers">
      <p><strong>Szervezők</strong></p>
      <p>{{data.organizers}}</p>
    </div>
    <div v-if="data.researchers">
      <p><strong>Kutatók</strong></p>
      <p>{{data.researchers}}</p>
    </div>
    <div v-if="data.photographers">
      <p><strong>Fotósok</strong></p>
      <p>{{data.photographers}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CompanyInfo',
    props: ['data']
  }
</script>

<style scoped>
  .info {
    padding: 40px;
    background-color: var(--colorA);
    text-align: left;
    box-sizing: border-box;
  }

  .info p {
    color: #fff;
    font-size: 18px;
  }

  .info p span {
    display: block;
  }

  .info strong {
    text-transform: uppercase;
  }

</style>
